module.exports = __webpack_public_path__ + "static/img/dyg.db68c29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dyg.png
// module id = C2Zb
// module chunks = 0